import * as React from 'react';
import { memo, ReactNode, useEffect } from 'react';

import { createPortal } from 'react-dom';

import { Modal } from 'atoms';

export interface IGlobalModalComponent {
  children: ReactNode;
  /**
   * The popup brings its own full-screen overlay (antd `<Modal>` or the `Modal`
   * atom) — render it bare, without a second scrim. See `SELF_CHROMED_POPUPS`.
   */
  bare?: boolean;
}

export const GlobalModalComponent = memo(
  ({ children, bare = false }: IGlobalModalComponent) => {
    useEffect(() => {
      if (children) {
        document.body.style.overflowY = 'hidden';
        return;
      }
      document.body.style.overflowY = 'auto';
    }, [children]);

    if (!children) return null;

    return createPortal(
      bare ? <>{children}</> : <Modal>{children}</Modal>,
      document.body,
    );
  },
);
